import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import {
  ArrowBackRounded as ArrowBackRoundedIcon,
  InfoOutlined as InfoIcon,
} from '@mui/icons-material';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';
import { USER_ROLES } from '../../constants/roles';
import { getCareTeamLensCopy } from './careTeamLensCopy';

const compactLineSx = {
  mt: 1.5,
  fontSize: '0.92rem',
  color: colors.landing.textMuted,
};

const CareTeamPageHeader = ({
  onBack,
  userRole,
  summaryText,
  child,
  showBack = true,
}) => {
  const isOwner = userRole === 'care_owner';
  const isCarePartner = userRole === USER_ROLES.CARE_PARTNER;
  const careTeamCopy = getCareTeamLensCopy(child);
  const subtitle = isOwner || isCarePartner
    ? careTeamCopy.ownerSubtitle
    : careTeamCopy.participantSubtitle;

  return (
    <Box sx={{ mb: 3 }}>
      {showBack ? (
        <Button
          startIcon={<ArrowBackRoundedIcon sx={{ fontSize: 18 }} />}
          onClick={onBack}
          sx={{
            mb: 1.25,
            px: 0,
            minWidth: 0,
            textTransform: 'none',
            fontWeight: 700,
            fontSize: '0.94rem',
            color: colors.landing.textMuted,
            '&:hover': {
              bgcolor: 'transparent',
              color: colors.landing.heroText,
            },
          }}
        >
          Back to Dashboard
        </Button>
      ) : null}

      <Box
        sx={{
          display: 'flex',
          alignItems: { xs: 'stretch', sm: 'center' },
          justifyContent: 'space-between',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 1.5,
          mb: summaryText ? 0.5 : 0,
        }}
      >
        <Box>
          <Typography sx={{ fontSize: { xs: '1.7rem', md: '2rem' }, fontWeight: 800, color: colors.landing.heroText, lineHeight: 1.1 }}>
            {careTeamCopy.pageTitle}
          </Typography>
          <Typography sx={{ mt: 0.6, fontSize: '0.98rem', color: colors.landing.textMuted, lineHeight: 1.5 }}>
            {subtitle}
          </Typography>
        </Box>
      </Box>

      {summaryText && (isOwner || isCarePartner) ? (
        <Typography sx={compactLineSx}>
          {summaryText}
        </Typography>
      ) : null}

      {summaryText && !(isOwner || isCarePartner) ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1.2,
            mt: 1.5,
            p: 1.25,
            borderRadius: 2,
            bgcolor: alpha(colors.landing.panelSoft, 0.75),
            border: `1px solid ${alpha(colors.landing.borderMedium, 0.55)}`,
          }}
        >
          <InfoIcon sx={{ fontSize: 18, color: colors.landing.textMuted, mt: '2px' }} />
          <Typography sx={{ fontSize: '0.92rem', color: colors.landing.textMuted, lineHeight: 1.55 }}>
            {careTeamCopy.participantInfo}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
};

export default CareTeamPageHeader;
